/* TLB v1.31 (t129u): on phones (<750px) the brand-page category bar pins under the sticky header
   while scrolling and returns to its place in the flow when scrolled back up. Desktop untouched. */
(function(){
  var bar=document.querySelector('.tlb-bpage .tlb-brand__chips');if(!bar)return;
  var root=bar.closest('[data-tlb-filter]');
  var mq=window.matchMedia('(max-width: 749px)');
  var st=document.createElement('style');
  st.textContent='@media(max-width:749px){.tlb-bpage .tlb-brand__chips{position:-webkit-sticky;position:sticky;top:var(--tlb-subnav-top,0px);z-index:3;background:var(--tlb-subnav-bg,#F7F3EA);transition:top .2s ease}'+
    '.tlb-bpage .tlb-brand__chips.is-stuck{box-shadow:0 6px 10px -8px rgba(41,36,30,.25)}'+
    '.tlb-bpage [data-tlb-filter] ul{scroll-margin-top:calc(var(--tlb-subnav-top,0px) + var(--tlb-subnav-h,48px) + 12px)}}';
  document.head.appendChild(st);
  var bg=getComputedStyle(document.body).backgroundColor;
  if(bg&&bg!=='rgba(0, 0, 0, 0)'&&bg!=='transparent')document.documentElement.style.setProperty('--tlb-subnav-bg',bg);
  var hdr=document.querySelector('#header-component')||document.querySelector('header-component');
  var ticking=false,lastTop=-1;
  function headerBottom(){
    if(!hdr)return 0;var r=hdr.getBoundingClientRect();
    var cs=getComputedStyle(hdr);if(cs.position!=='sticky'&&cs.position!=='fixed'&&r.bottom<=0)return 0;
    return Math.max(0,Math.round(r.bottom));
  }
  function update(){
    ticking=false;
    if(!mq.matches){bar.classList.remove('is-stuck');return}
    var t=headerBottom();
    if(t!==lastTop){lastTop=t;document.documentElement.style.setProperty('--tlb-subnav-top',t+'px')}
    document.documentElement.style.setProperty('--tlb-subnav-h',bar.offsetHeight+'px');
    var r=bar.getBoundingClientRect();
    bar.classList.toggle('is-stuck',window.scrollY>0&&Math.abs(r.top-t)<1.5);
  }
  function req(){if(!ticking){ticking=true;requestAnimationFrame(update)}}
  window.addEventListener('scroll',req,{passive:true});
  window.addEventListener('resize',req);
  if(mq.addEventListener)mq.addEventListener('change',req);
  if(hdr){hdr.addEventListener('transitionend',req);if(window.ResizeObserver)new ResizeObserver(req).observe(hdr)}
  update();setTimeout(update,300);
  /* Tapping a category while pinned: keep the tapped chip in view and bring the top of the filtered grid just under the bar. */
  bar.addEventListener('click',function(e){
    var b=e.target.closest('[data-f]');if(!b||!mq.matches)return;
    var wasStuck=bar.classList.contains('is-stuck');
    requestAnimationFrame(function(){
      var bl=bar.getBoundingClientRect(),cl=b.getBoundingClientRect();
      if(cl.left<bl.left+16||cl.right>bl.right-16)bar.scrollTo({left:bar.scrollLeft+(cl.left-bl.left)-(bl.width-cl.width)/2,behavior:'smooth'});
      if(!wasStuck)return;
      var list=root&&root.querySelector('ul');if(!list)return;
      var y=window.scrollY+list.getBoundingClientRect().top-headerBottom()-bar.offsetHeight-12;
      window.scrollTo({top:Math.max(0,y),behavior:'smooth'});
    });
  });
})();
